import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ApiService, AppDispatch, RootState, navigate } from "src/common";
import { AppRoutes } from "src/pages/app";

// ============ INTERFACE ============

export interface OfferStateInterface {
  data?: any;
  offerId?: string;
  oneTimeToggle?: boolean;
  oneTimeOffersToggle?: boolean;
  bListToggle?: boolean;
  soId?: string;
  soIdWeb?: string;
  paymentType?: string;
  formValues?: { [key: string]: any };
  isContractorSameAsInsuredPerson?: boolean;
}

// ============ INIT STATE ============

const initialState: OfferStateInterface = {
};

// ========= SLICE ==========

export const OfferSlice = createSlice({
  name: 'offer',
  initialState,
  reducers: {
    setOfferId: (state: OfferStateInterface, action: PayloadAction<any>) => {
      state.offerId = action.payload
    },
    setSoId: (state: OfferStateInterface, action: PayloadAction<any>) => {
      state.soId = action.payload
    },
    setSoIdWeb: (state: OfferStateInterface, action: PayloadAction<any>) => {
      state.soIdWeb = action.payload
    },
    setPaymentType: (state: OfferStateInterface, action: PayloadAction<any>) => {
      state.paymentType = action.payload
    },
    setOneTimeToggle: (state: OfferStateInterface, action: PayloadAction<boolean>) => {
      state.oneTimeToggle = action.payload
    },
    setOneTimeOffersToggle: (state: OfferStateInterface, action: PayloadAction<boolean>) => {
      state.oneTimeOffersToggle = action.payload
    },
    setBListToggle: (state: OfferStateInterface, action: PayloadAction<boolean>) => {
      state.bListToggle = action.payload
    },
    setFormState: (state: OfferStateInterface, action: PayloadAction<{ reduxName: string, formValues: any }>) => {
      const { reduxName, formValues } = action.payload;
      if (!state.formValues) {
        state.formValues = {};
      }
      state.formValues[reduxName] = formValues;
    },
    resetFormState: (state: OfferStateInterface) => {
      state.formValues = undefined;
      state.isContractorSameAsInsuredPerson = true;
    },
    setIsContractorSameAsInsuredPersonStore: (state: OfferStateInterface, action: PayloadAction<boolean>) => {
      state.isContractorSameAsInsuredPerson = action.payload
    }
  }
})

export const { setOfferId, setOneTimeToggle, setBListToggle, setOneTimeOffersToggle, setSoId, setSoIdWeb, setPaymentType, setFormState, resetFormState, setIsContractorSameAsInsuredPersonStore } = OfferSlice.actions;

export default OfferSlice.reducer;

export const createOffer = (productCode: string) => (dispatch: AppDispatch, getState: () => RootState) => {
  const customer = getState().model.customer.data;
  ApiService.createOffer(productCode, customer).subscribe({
    next: (response: any) => {
      const urlParams = new URLSearchParams(new URL(response.data.checkoutUrl).search);
      const offerId = urlParams.get('OfferID');
      dispatch(setOfferId(offerId));
      navigate(`${AppRoutes.OFFER.fullPath}/${offerId}`);
    },
    error: () => {
      console.log('Error while creating offer')
    },
  });
};
